import { useAuthorization } from "@sttedra_ui/framework";

import UsersGroupsView from "../users-groups/UsersGroupsView.vue";

export default [
  {
    path: "/admin/UsersGroups",
    name: "UsersGroups",
    component: UsersGroupsView,
    meta: { title: "Grupos de usuarios", requiresAuthentication: false },
    beforeEnter: async (to, from, next) => {
      localStorage.setItem("layout", "admin");

      const { modelRef: authorizationModelRef } = useAuthorization();

      const userRol = authorizationModelRef.value.roles[0];

      if (userRol != "Admin") {
        next({ name: "Login" });
      }

      next();
    },
  },
];
